import { useRef } from 'react';
import { Box, Button } from '@mui/material';
import { useAtomValue } from 'jotai';
import { dump } from 'js-yaml';

import { ReactAsf } from '@attackiq/react-asf';

import { schemaAtom, toggleAtom } from '../list';

/**
 * The model an AngularJS schema-form builds from its JSON Schema: keys are the
 * schema's property names, so nothing narrower is knowable here. `ReactAsf` is
 * an untyped `.jsx`, so this annotation is what gives `onModelChange` a type.
 */
type AsfModel = Record<string, unknown>;

const UIPreview = () => {
  const modelRef = useRef<AsfModel>({});
  const toggledValue = useAtomValue(toggleAtom);
  const schema = useAtomValue(schemaAtom);
  const { form, config } = schema;

  const handleModelChange = (newModel: AsfModel) => {
    modelRef.current = newModel;
  };

  const handleCopyModel = () => {
    navigator.clipboard.writeText(dump(modelRef.current));
  };

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box sx={{ flex: '1 0 0', overflow: 'hidden' }}>
        <ReactAsf
          toggle={toggledValue}
          form={form}
          schema={config}
          model={{}}
          onModelChange={handleModelChange}
          fullHeight
        />
      </Box>

      <Button variant="contained" onClick={handleCopyModel}>
        Copy Model.YAML
      </Button>
    </Box>
  );
};

export default UIPreview;
